<template>
    <div>
        <Dropdown
            :error-state="errors['pick-your-campaign']"
            id="select-my-campaign-modal"
            heading="Pick your campaign*"
            :text="selectedCampaign && selectedCampaign.title || 'Select Your Campaign'"
            :items="campaigns || []"
            @setItem="setCamp"
            key-placeholder="camps-list"
            :max-height="280"
        />
        <SendMessage 
            v-if="errors['no-update-date-partner'] || errors['all-spots-are-taken-partner'] && !pending"
            :owner = 'selectedCampaign'
            :partner = 'partner.campaign'
            @hideModal = 'hideModal'
        />
        <div v-else class="default-state d-flex flex-column" style="height: 305px;">
            <div v-if="selectedCampaign && selectedCampaign.id && !pending">
                <div v-if="errors['no-update-date']" class="d-flex flex-column">
                    <SendMessage 
                        :owner = 'selectedCampaign'
                        :partner = 'partner.campaign'
                        @hideModal = 'hideModal'
                        :short = "true"
                        label = "Request CrossProm through message"
                    />
                </div>
                <div v-else>
                    <Dropdown
                        :error-state="errors['pick-date'] || errors['already-requested']"
                        heading="Suggest your update*"
                        :text="selectedSpot && selectedSpot.date || 'Select Update Dates'"
                        :items="scheduler"
                        @setItem="setSpots"
                        id="my-dates-dropdown-modal"
                        key-placeholder="update-dates"
                        :max-height="150"
                    />
                    <p v-if="errors['already-requested']" class="pt-2 error-state-texts">
                        You have already requested cross-promotion for this date
                    </p>
                    <div v-else>
                        <div
                            v-if="!errors['all-spots-are-taken']"
                            class="comment-box mt-4">
                            <p class="lab c6 mb-0">Add a message (optional)</p>
                            <textarea
                                id="spot-message-input-chatroom"
                                class="w-100"
                                v-model.trim = 'comment'
                            />
                            <p id="message-limit-error" v-if="errors['long-comment']" class="error-state-texts">
                                You have reached your maximum limit of characters allowed (1200 symbols)
                            </p>
                        </div>
                        <p class="error-state-texts" v-else>
                            All spots on this date are taken. Pick another date or add a spot to this update.
                        </p>
                        <div
                            v-if="spots.length"
                            class="spots-box mt-4 position-relative"
                            :class="{'error-state': errors['pick-spot'] || errors['all-spots-are-taken']}">
                            <p class="lab c6 mb-0">
                                Suggest the spot*
                            </p>
                            <SpotsList
                                id="my-campaign-spots"
                                @selectSpot="selectSpot"
                                :spots="spots"
                                :selected-spot="selectedSpot"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Dropdown from './Crumbs/Dropdown'
import SpotsList from "./Crumbs/SpotsList";
import SendMessage from './Crumbs/SendMessage'
import ScheduleUpdates from './SubmitButton/ScheduleUpdate'

import { watch, ref } from '@vue/composition-api';
import { useOwner, useSpots, useErrors } from '../../core/hooks';

export default {
    name: 'OwnerPart',
    components: {
        Dropdown,
        SpotsList,
        ScheduleUpdates,
        SendMessage
    },

    props: {
        campaigns: Array,
        partner: Object,
        hideModal: Function,
        pending: Boolean
    },
    
    setup(props, context){

        const comment = ref('');
        const errors = useErrors().messages;

        const {
            selectedCampaign,
            setCamp,
        } = useOwner(props.campaigns, props.partner.spots);

        const {
            spots,
            selectedSpot,
            scheduler,
            selectSpot,
            initSpots,
            setSpots,
        } = useSpots(selectedCampaign && selectedCampaign.id);


        // set new scheduler on campaign change
        watch(selectedCampaign, (campaign) => {
            initSpots(campaign.id);
            context.emit('setPending', true)
            setTimeout(() => {
                context.emit('setPending', false)
            }, 500)
        })


        // watch variable changes, gather them in an object and send it to index file
        watch([selectedCampaign, comment, selectedSpot], ([selectedCampaign, comment, selectedSpot]) => {
            context.emit('newOwner', {
                selectedCampaign,
                comment,
                selectedSpot,
            })
        })

        return {
            selectedCampaign,
            errors,
            setCamp,
            spots,
            selectedSpot,
            scheduler,
            selectSpot,
            setSpots,
            comment
        }
    }
}
</script>


<style lang="scss">
    .side-container {
        .message-state {
            textarea {
                height: 135px;
                border: 1px solid #C7C4C4;
                border-radius: 3px;
                resize: none;
            }
            button {
                width: 100px;
                height: 32px;
            }
        }
        .comment-box {
            textarea {
                height: 62px !important;
                padding-left: 4px;
                resize: none;
                font-size: 11px;
                color: #98A6AD;
                border: 1px solid #C7C4C4;
                box-sizing: border-box;
            }
        }
        button {
                height: 32px;
        }
    }
</style>